<h3>Transportscheine</h3>
<clr-datagrid *ngIf="!!transport" [clrDgLoading]="loading">
  <clr-dg-column [clrDgField]="'transport_id'">Transportschein</clr-dg-column>
  <clr-dg-column [clrDgField]="'order_id'">zu Auftrag</clr-dg-column>
  <clr-dg-column [clrDgField]="'company_name'">Kunde/Betreff</clr-dg-column>
  <clr-dg-column [clrDgField]="'dateI'">Datum</clr-dg-column>
  <clr-dg-column>Status</clr-dg-column>
  <clr-dg-placeholder>We couldn't find any Transport Document!</clr-dg-placeholder>
  <clr-dg-row *clrDgItems="let delivery of transport" [routerLink]="['/transport/details', delivery.project_id, jobId, delivery.transport_id, delivery.order_id]">
    <clr-dg-cell>{{ delivery.project_id }}.0005.{{ delivery.transport_id }}</clr-dg-cell>
    <clr-dg-cell>{{ delivery.project_id }}.0002.{{ delivery.order_id}}</clr-dg-cell>
    <clr-dg-cell><b>{{ delivery.company_name }}</b><br />{{ delivery.name_project }}</clr-dg-cell>
    <clr-dg-cell>{{ delivery.delivery_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
    <clr-dg-cell [className]="findButtonClass(delivery.status)" role="alert">
      <div class="alert-items">
        <div class="alert-item static">
          <div class="alert-icon-wrapper">
            <cds-icon *ngIf="delivery.status === 'running'" class="alert-icon" shape="info-circle"></cds-icon>
            <cds-icon *ngIf="delivery.status === 'closed'" class="alert-icon" shape="check-circle"></cds-icon>
            <cds-icon *ngIf="delivery.status === 'ontour'" class="alert-icon" shape="exclamation-circle"></cds-icon>
            <cds-icon *ngIf="delivery.status === 'onhold'" class="alert-icon" shape="exclamation-triangle"></cds-icon>
          </div>
          <span *ngIf="delivery.status === 'running'" class="alert-text">In Arbeit</span>
          <span *ngIf="delivery.status === 'closed'" class="alert-text">Empfang bestätigt</span>
          <span *ngIf="delivery.status === 'onhold'" class="alert-text">Wartet auf Abholung</span>
          <span *ngIf="delivery.status === 'ontour'" class="alert-text">On Tour</span>
        </div>
      </div>
    </clr-dg-cell>
  </clr-dg-row>
  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="50">
      <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Transportscheine pro Seite</clr-dg-page-size>
      {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
      von  {{ transport.length }} Transportschein(en)
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>
